<div class="pane-info">
  <app-loading *ngIf="loading" [size]="'1x'"></app-loading>
  <div *ngIf="!loading && html" class="pane-info__body" [innerHTML]="html"></div>
  <div *ngIf="!loading && !html" class="pane-info__empty">
    {{ 'pane-info.empty.text' | translate }}
  </div>
</div>
